// Shared keyboard-shortcut helpers for the action forms.
//
// Ctrl+Enter (or Cmd+Enter on macOS) submits the focused form — including
// from inside a multi-line Textarea, where a plain Enter inserts a newline.
// keydown bubbles up the DOM, so attaching the handler on the wrapping
// <form>/<div> catches keystrokes from the inputs inside it.

export function isCtrlEnter(e: KeyboardEvent): boolean {
  return (e.ctrlKey || e.metaKey) && e.key === "Enter";
}
